import { useStyles } from "./Module1Icon.styles";
import { IModule1Icon } from "./Module1IconInterfaces";

const Module1Icon = ({ className, hideBackground }: IModule1Icon) => {
    const classes = useStyles();
    return (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 54 54"
            className={`${classes.mainModule1IconWrapper} ${className || ""}`}
        >
            <defs>
                <clipPath id="clippath">
                    <rect x="9.5" y="13" width="35" height="28" fill="none" strokeWidth="0" />
                </clipPath>
            </defs>
            {!hideBackground && (
                <path
                    d="M27,0h0c14.91,0,27,12.09,27,27h0c0,14.91-12.09,27-27,27h0C12.09,54,0,41.91,0,27h0C0,12.09,12.09,0,27,0Z"
                    fill="#EF3340"
                    strokeWidth="0"
                />
            )}
            <g clipPath="url(#clippath)">
                <path
                    d="M30.03,35.13c.54,0,.98-.44.98-.98v-5.72c-.74-.53-1.4-1.17-1.96-1.89v7.61c0,.54.44.98.98.98Z"
                    fill="#FFFFFF"
                    stroke="#FFFFFF"
                    strokeWidth=".2"
                />
                <path
                    d="M35.89,35.13c.54,0,.98-.44.98-.98v-3.98c-.14,0-.27.02-.41.02-.53,0-1.04-.06-1.55-.14v4.1c0,.54.44.98.98.98Z"
                    fill="#FFFFFF"
                    stroke="#FFFFFF"
                    strokeWidth=".2"
                />
                <path
                    d="M39.8,39.04H14.39c-1.62,0-2.93-1.31-2.93-2.94V14.59c0-.54-.44-.98-.98-.98s-.98.44-.98.98v21.51c0,2.7,2.19,4.89,4.89,4.89h25.41c.54,0,.98-.44.98-.98s-.44-.98-.98-.98Z"
                    fill="#FFFFFF"
                    stroke="#FFFFFF"
                    strokeWidth=".2"
                />
                <path
                    d="M24.16,35.13c.54,0,.98-.44.98-.98v-13.69c0-.54-.44-.98-.98-.98s-.98.44-.98.98v13.69c0,.54.44.98.98.98Z"
                    fill="#FFFFFF"
                    stroke="#FFFFFF"
                    strokeWidth=".2"
                />
                <path
                    d="M18.3,35.13c.54,0,.98-.44.98-.98v-5.87c0-.54-.44-.98-.98-.98s-.98.44-.98.98v5.87c0,.54.44.98.98.98Z"
                    fill="#FFFFFF"
                    stroke="#FFFFFF"
                    strokeWidth=".2"
                />
                <path
                    d="M44.5,20.89c0,4.36-3.53,7.89-7.88,7.89s-7.88-3.53-7.88-7.89c0-2.21.91-4.2,2.37-5.64.39-.38,1.02-.38,1.4.02.38.39.37,1.01-.02,1.4-1.09,1.07-1.77,2.57-1.77,4.22,0,3.27,2.65,5.92,5.91,5.92s5.91-2.65,5.91-5.92c0-2.93-2.13-5.37-4.93-5.83v.9c0,.55-.44.99-.99.99s-.99-.44-.99-.99v-1.97c0-.55.44-.99.99-.99,4.35,0,7.88,3.53,7.88,7.89Z"
                    fill="#FFFFFF"
                    stroke="#FFFFFF"
                    strokeWidth=".2"
                />
                <path
                    d="M37.14,20.37c.29.29.29.75,0,1.04-.29.29-.75.29-1.04,0l-2.47-2.47c-.29-.29-.29-.75,0-1.04.29-.29.75-.29,1.04,0l2.47,2.47Z"
                    fill="#FFFFFF"
                    stroke="#FFFFFF"
                    strokeWidth=".4"
                />
            </g>
        </svg>
    );
};

export default Module1Icon;
